var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("clickable",null,{"toggle":_vm.toggleClass,"activeClass":_vm.activeClass}),_vm._t("submenu",null,{"toggle":_vm.toggleClass})],2)}
var staticRenderFns = []

export { render, staticRenderFns }